import _ from 'lodash';

class CheckFunctions {

    static checkCF(cf) {
        if (_.isUndefined(cf) || _.isEmpty(cf)) {
            return false;
        }

        var valid, i, s, set1, set2, setpari, setdisp;

        cf = cf.toUpperCase();
        if (cf.length !== 16)
            return false;
        valid = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        for (i = 0; i < 16; i++) {
            if (valid.indexOf(cf.charAt(i)) === -1)
                return false;
        }
        set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
        setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
        s = 0;
        for (i = 1; i <= 13; i += 2)
            s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        for (i = 0; i <= 14; i += 2)
            s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        if (s % 26 !== cf.charCodeAt(15) - 'A'.charCodeAt(0))
            return false;
        return true;
    }

    static checkPIVA(pi) {
        if (_.isUndefined(pi) || _.isEmpty(pi)) {
            return false;
        }
        if (pi.length !== 11) {
            return false;
        }

        var valid = '0123456789';
        for (var i = 0; i < 11; i++) {
            if (valid.indexOf(pi.charAt(i)) === -1)
                return false;
        }
        var s = 0;
        for (i = 0; i <= 9; i += 2)
            s += pi.charCodeAt(i) - '0'.charCodeAt(0);
        for (i = 1; i <= 9; i += 2) {
            var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
            if (c > 9) c -= 9;
            s += c;
        }
        if ((10 - s % 10) % 10 !== pi.charCodeAt(10) - '0'.charCodeAt(0))
            return false;
        return true;
    }

    static checkEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}

export default CheckFunctions;